import {AbroadAddonsDataType} from 'Models/Content/AbroadAddonsDataData';

export interface AbroadPackageClientModelResponse {
  Body: AbroadPackageResponse;
}

export type PackageDurationUnit = 'Day' | 'Month' | '' | null;

export interface AbroadPackageResponse {
  matchExact: AbroadPackageModel[];
  validyButNotExact: AbroadPackageModel[];
  businessOrgMatchPackages?: AbroadPackageModel[];
  businessIndividual?: boolean;
}

export interface AbroadPackagesPopularModelResponse {
  Body: AbroadPackageModel[];
}

export interface AbroadPackageModel {
  length?: number;
  blockId?: string;
  labelEpi?: string;
  titleEpi?: string;
  packageDuration?: number | null;
  packageDurationUnit?: PackageDurationUnit;
  type?: PackageType;
  isBankOrByUse?: IsBankOrByUse;
  packageDetailsList?: PackageDetails[];
  iconAppEpi?: string[];
  price?: number | null;
  priceDeleted?: number | null;
  buttonValue?: string;
  policiesEpi?: string;
  dataForApp?: DataForApp;
  importantInfo?: string[];
  displayImportantToKnow: boolean;
  countrySupportedList?: AbroadCountryPackage[];
  countryNotSupportedList?: AbroadCountryPackage[];
  countrySupportedDictionary?: StateDictionary;
  tagTextSecondary?: string;
  socCode?: string;
  isRecurringPayment?: boolean;
  textUnderPackage?: string;
  textInsideTooltipPackage?: string;
  isSearch?: boolean;
  matchType?: MatchType;
  countrySearchedButNotSupported?: AbroadCountryPackage[];
  numberOfTripAllowed?: number;
  packageBankExpirationDate?: string;
  isGiveFamilyBonus?: boolean;
  isFamilyBonus?: boolean;
  isFamilyBundle?: boolean;
  socCodeFamilyBonus?: string;
  socCodeGiveFamilyBonus?: string;
  familyPackageDescriptionFromPackageManager?: string;
  familyPackageData: AbroadPackageModel;
  addonsPackage: AbroadAddonsDataType[];
  steppedPerDay?: boolean;
}

export enum MatchType {
  Null = 'Null',
  StateNotMatch = 'StateNotMatch',
  DateNotMatch = 'DateNotMatch',
  StateAndDateNoteMatch = 'StateAndDateNoteMatch',
}
export interface StateDictionary {
  א?: string;
  ב?: string;
  ג?: string;
  ד?: string;
  ה?: string;
  ו?: string;
  ז?: string;
  ח?: string;
  ט?: string;
  י?: string;
  כ?: string;
  ל?: string;
  מ?: string;
  נ?: string;
  ס?: string;
  ע?: string;
  פ?: string;
  צ?: string;
  ק?: string;
  ר?: string;
  ש?: string;
  ת?: string;
}
export interface QualificationStateListOptimized {
  StateHEB: string;
  StateENG: string;
  StateCode: string;
}

export interface AbroadCountryPackage {
  StateHEB: string;
  StateCode: string;
}

export interface AbroadCountryPackageDetails {
  countryHebName: string;
  countryCode: string;
}

export enum PackageType {
  Voice = 'Voice',
  Sms = 'Sms',
  Data = 'Data',
  VoiceSmsData = 'VoiceSmsData',
  VoiceAndSmsData = 'VoiceAndSmsData',
  VoiceSms = 'VoiceSms',
  VoiceAndSms = 'VoiceAndSms',
  FAMILY_BUNDLE = 'FamilyBundle',
}

export interface PackageDetails {
  voice: ValueDetails;
  sms: ValueDetails;
  data: ValueDetails;
  countrySupportedList: AbroadCountryPackageDetails[];
}

export interface ValueDetails {
  unit: UnitMeasureCodeOptionsFeature | null;
  value: number | null;
  priceByUsage: number | null;
  unitByUsage: UnitOptionsAmountObject | null;
  isUnlimited: boolean;
  quantity: number | null;
}

export enum UnitMeasureCodeOptionsFeature {
  Minutes = 'Minutes',
  TenthOfMB = 'Tenth Of MB',
  OccurrencesCall = 'Occurrences Call',
  OccurrencesMessage = 'Occurrences Message',
  KB = 'KB',
  MB = 'MB',
  Irrelevant = 'Irrelevant',
  ILS = 'ILS',
  Prorated = 'Prorated',
  GB = 'GB',
  MultiFeatures = 'MultiFeatures',
  PerDay = 'PerDay',
  Empty = 'Empty',
}

export enum UnitOptionsAmountObject {
  ILS = 'ILS',
  שקל = 'שקל',
}

export enum IsBankOrByUse {
  Bank = 'Bank',
  ByUse = 'ByUse',
}
export interface ObjectWithField{
  effectivePackagesToShow?: [];
}
export interface AbroadPackageClientState {
  page: 'sale' | 'lobby';
  startedFromPackage: boolean;
  isLoading: boolean;
  popularIsLoading: boolean;
  searchIsLoading: boolean;
  abroadPackagesPopular?: AbroadPackageModel[];
  abroadPackagesPopularMarket?: AbroadPackageModel[];
  abroadPackagesList?: AbroadPackageResponse;
  getEpiGeneralData?: {supportedApps?: SupportedSocialMediaApplications[]};
  activeLobbyTab?: lobyTabsEnum;
  otpData?: OtpData;
  epiStyleInitializationData: EpiStyleInitializationData;
  selectedAbroadPackage: AbroadPackageModel;
  isJETAuthentication: string;
  statusRequest: string;
  userUsageDataCompleted:boolean;
  userUsageData: string | ObjectWithField;
  customerAbroadPackages:[] | string;
  customerAbroadPackagesRequestCompleted:boolean;
  isCancelOrUpdatePackagePending:boolean;
  isCancelOrUpdatePackageIsCompletedSuccessfuly:boolean;
}

export interface SubscriberModel{
  abroadInd:string;
  abroadSocInd:string;
  productSubscriberNo:string;
}

export enum lobyTabsEnum {
  PRIVATE = 'private',
  PACKAGEEXISTS = 'packageExists',
  BUSINESSACCOUNT = 'businessAccount',
}
export interface SupportedSocialMediaApplications {
  appIcon?: string;
  appDarkIcon?: string;
  appName?: string;
}

export interface DataForApp {
  hasDataForApp?: boolean;
  isUnlimitedDataForApp?: boolean;
  valueDataForApp?: number;
  unit?: UnitMeasureCodeOptionsFeature;
}

export interface OtpData {
  validatedCostumerData?: ValidatedCostumerData;
}

export interface ValidatedCostumerData {
  isSeparatedSale?: boolean;
  accountType?: ClientType;
}
export interface EpiStyleInitializationData {
  pageRefToExtendedPackagesPrivate?: string;
  pageRefToExtendedPackagesBusiness?: string;
}

export enum ClientType {
  PRIVATE = 'Private',
  BUSINESS = 'Business',
}

export enum PackageOrigin {
  SEARCH = 'Search',
  POPULAR = 'Popular',
  POPULAR_MARKET = 'PopularMarket'
}

export enum AbroadSocType {
  REGULAR_SOC = 'regularSoc',
  ADDON_SOC = 'addonSoc',
}
export interface RootState {
  cellcomAbroad: AbroadPackageClientState;
}

export enum AddonType {
  Abroad = 'AbroadSoc',
  Coupon = 'Coupon',
}

export enum OrganizationType {
  NONE,
  IDF,
}
